controllers.controller('LoginOTPController', [
    '$scope', '$state', 'LocaleService', 'LoginService', 'UserService', 'AccountService', 'Validator', '$stateParams',
    '$ionicLoading', '$injector', 'constants',
    function ($scope, $state, LocaleService, LoginService, UserService, AccountService, Validator, $stateParams,
              $ionicLoading, $injector, Const) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.navigate = function (state) {
            $state.go(state);
        };

        if (!$stateParams.loginData) {
            $state.navigate('login');
        }
        $scope.loginForm = {
            otpCode: ''
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.validator = Validator.getPattern;

        $scope.login = function (form) {

            if (!form.$valid) return;

            //if we are already logged in mt4 account
            var user = UserService.get();
            if (user && user.isLoggedInMT4) {
                return $state.go('root.app.assets', {cache: false});
            }

            $scope.loadingMessage = LocaleService.translation.logging_in;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            LoginService.login($stateParams.loginData.email, $stateParams.loginData.password, $scope.loginForm.otpCode)
                .then(function () {
                    $scope.loadingMessage = LocaleService.translation.starting;
                })
                .then(LoginService.initServices)
                .then(function () {

                    $injector.get('Init').isInitialized = true;
                    $ionicLoading.hide();

                    var state = AccountService.checkTradingAccounts();
                    if (state) return $state.go(state);

                    $state.go('root.app.assets');
                })
                .catch(function (error) {

                    // if (error === Const.loginStatus.failedActiveAccount) {
                    if (error && error.code === "authFailed") {
                        $ionicLoading.hide();
                        //popup
                        $scope.modal.isError = true;
                        $scope.modal.textTitle = LocaleService.translation.messages.mt4AuthFailed;
                        $scope.modal.back = 'login';
                        $scope.modal.state = true;
                        return;
                    }

                    //if we failed in starting any service - do logout sequence
                    LoginService.logout()
                        .then(function () {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                })


        };

    }]);
